/**
 * THE MONTHS AN ACCOUNTANT CAN CLOSE: the running one up to yesterday (a day
 * still being traded cannot be booked), then whole calendar months back.
 */

import { daysBefore } from "./format";

export interface ExportMonth {
  /** YYYY-MM */
  readonly key: string;
  readonly from: string;
  readonly to: string;
  /** The running month, cut at yesterday. */
  readonly partial: boolean;
}

export function exportMonths(today: string, count = 13): ExportMonth[] {
  const [year, month] = today.split("-").map(Number) as [number, number];
  const yesterday = daysBefore(today, 1);
  const out: ExportMonth[] = [];
  for (let back = 0; out.length < count; back++) {
    const from = new Date(Date.UTC(year, month - 1 - back, 1)).toISOString().slice(0, 10);
    const last = new Date(Date.UTC(year, month - back, 0)).toISOString().slice(0, 10);
    const to = last < today ? last : yesterday;
    if (to < from) continue;
    out.push({ key: from.slice(0, 7), from, to, partial: to !== last });
  }
  return out;
}
